import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface StopCompleteManagementIconProp extends Omit<SvgIconProps, `color`> {
  color?: string;
}

export const StopCompleteManagementIcon = ({
  color = RoutalPalette.stopStatusColors.completed.dark,
  style,
  ...props
}: StopCompleteManagementIconProp) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={style}>
      <path
        d="M21.1323 5.37597C20.6283 4.34397 19.9083 3.43197 18.9963 2.63997C18.0723 1.84797 16.9923 1.23597 15.7923 0.815969C14.5803 0.383969 13.3083 0.167969 12.0003 0.167969C9.3603 0.167969 6.87631 1.04397 5.0043 2.63997C3.1443 4.23597 2.1123 6.34797 2.1123 8.59197C2.1123 11.88 3.6243 15.372 6.6243 18.96C7.5723 20.088 9.14431 21.816 11.3163 23.568L11.4243 23.652C11.5923 23.772 11.7963 23.832 12.0123 23.832C12.2283 23.832 12.4083 23.772 12.6243 23.628C12.6243 23.628 15.0363 21.828 17.4123 18.972C20.3523 15.432 21.9003 11.844 21.9003 8.60397C21.9003 7.48797 21.6483 6.40797 21.1443 5.37597H21.1323ZM14.5683 9.51597C13.6803 9.92397 12.9603 10.644 12.5523 11.52L12.0123 12.684L11.4723 11.52C11.0643 10.644 10.3443 9.92397 9.45631 9.51597L8.28031 8.97597L9.45631 8.43597C10.3443 8.02797 11.0643 7.30797 11.4723 6.43197L12.0123 5.26797L12.5523 6.43197C12.9603 7.30797 13.6803 8.02797 14.5683 8.43597L15.7443 8.97597L14.5683 9.51597Z"
        fill={color}
      />
      <circle cx="12.0063" cy="9.30688" r="5.45996" fill={color} />
      <path
        d="M8.08618 10.5112L9.89254 12.3176L15.9137 6.29639"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};
